"use strict";
/**
 *  Copyright (c) Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the license found in the
 *  LICENSE file in the root directory of this source tree.
 */

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var debounce_1 = require("graphiql/dist/utility/debounce");
var graphcool_styles_1 = require("graphcool-styles");
var cx = require("classnames");
var SearchBox = function (_super) {
    __extends(SearchBox, _super);
    function SearchBox(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            _this.setState({ value: event.target.value });
            _this._debouncedOnSearch();
        };
        _this.state = { value: '' };
        _this._debouncedOnSearch = debounce_1.default(200, function () {
            _this.props.onSearch(_this.state.value);
        });
        return _this;
    }
    SearchBox.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextProps.isShown !== this.props.isShown || nextState.value !== this.state.value;
    };
    SearchBox.prototype.render = function () {
        return React.createElement(
            "div",
            { className: cx(!this.props.clean && 'root'), "data-jsx": 1554949702
            },
            React.createElement(_style2.default, {
                styleId: 1554949702,
                css: ".label[data-jsx=\"1554949702\"] {padding: 12px 14px 13px 15px;box-shadow: 0 1px 3px rgba(0, 0, 0, .1);}.pa25,\n.root[data-jsx=\"1554949702\"] {padding: 25px;}.bgBlack02,\n.root[data-jsx=\"1554949702\"] {background-color: rgba(0,0,0,.02);}.bgWhite,\n.label[data-jsx=\"1554949702\"] {background-color: #fff;}.bbox,\n.label[data-jsx=\"1554949702\"] {box-sizing: border-box;}.w100,\n.label[data-jsx=\"1554949702\"] {width: 100%;}.flex,\n.label[data-jsx=\"1554949702\"] {display: -ms-flexbox;display: flex;}.itemsCenter,\n.label[data-jsx=\"1554949702\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.bgWhite,\n.label[data-jsx=\"1554949702\"] {background-color: #fff;}.f16,\n.input[data-jsx=\"1554949702\"] {font-size: 16px;}.ml10,\n.input[data-jsx=\"1554949702\"] {margin-left: 10px;}"
            }),
            this.props.isShown && React.createElement(
                "label",
                { className: "label", "data-jsx": 1554949702
                },
                React.createElement(graphcool_styles_1.Icon, { src: require('graphcool-styles/icons/stroke/search.svg'), stroke: true, strokeWidth: 3 }),
                React.createElement("input", { className: "input", onChange: this.handleChange, type: "text", value: this.state.value, placeholder: this.props.placeholder || 'Search the schema ...', "data-jsx": 1554949702
                })
            )
        );
    };
    return SearchBox;
}(React.Component);
exports.default = SearchBox;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/GraphiQL/DocExplorer/SearchBox.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/GraphiQL/DocExplorer/SearchBox.js
// module chunks = 0